// v1
// import { Meta } from "../../meta/meta";
// import useMediaQuery from "../../hooks/useMediaQuery";
// import { useTranslation } from "react-i18next";
// import { useState } from "react";
// import { Loader } from "../../components/ui/loader";
// import useQueryParams from "../../hooks/useQueryParams";
// import { Title } from "../../components/ui/typography/title";
// import { GoBack } from "../../components/ui/goBack";
// import { useNavigate } from "react-router-dom";
// import ReactPaginate from "react-paginate";
// import { getYearFromDateString } from "../../utils/formatters";
// import { useTanstack } from "../../hooks/useTanstack";
// import { smoothScroll } from "../../utils/helpers";
// import styles from "./news.module.scss";

// const News = () => {
//   const navigate = useNavigate();
//   const { t } = useTranslation();
//   const { data } = useTanstack("getWebNews");
//   const mobile = useMediaQuery(`( max-width: 768px )`);

//   const currentYear = new Date().getFullYear();
//   const [year, setYear] = useQueryParams(["year"], "all");
//   const [page, setPage] = useQueryParams(["page"], 1);

//   // const [selectedPage, setSelectedPage] = useState(1);
//   const [itemOffset, setItemOffset] = useState(0);

//   const years = Array.from(
//     { length: currentYear - 2023 + 1 },
//     (_, index) => 2023 + index
//   );

//   const filteredNews =
//     year === "all"
//       ? data
//       : data?.filter(
//           (item) => getYearFromDateString(item.date) === Number(year)
//         );

//   const itemsPerPage = 6;
//   const endOffset = itemOffset + itemsPerPage;
//   const pageCount = Math.ceil((filteredNews?.length || 0) / itemsPerPage);
//   const currentNews = filteredNews?.slice(itemOffset, endOffset);

//   const selectYear = (selectedYear) => {
//     setItemOffset(0);
//     setPage({ page: 1 });
//     setYear({ year: selectedYear });
//   };

//   const handlePageClick = (event) => {
//     const newOffset = (event.selected * itemsPerPage) % filteredNews.length;

//     setItemOffset(newOffset);
//     setPage({ page: event.selected + 1 });
//     smoothScroll();
//   };

//   const arrowPrev = !mobile ? t("prev") : "<";
//   const arrowNext = !mobile ? t("next") : ">";

//   return (
//     <>
//       <Meta title="news" />
//       <main className={styles.news}>
//         <div className="container">
//           <div className={styles.news_top}>
//             <GoBack />
//             <Title text="news" />
//           </div>
//         </div>

//         <div className={styles.news_date}>
//           <div className="container">
//             <div className={styles.news_date_main}>
//               {years.map((el) => (
//                 <button
//                   key={el}
//                   className={
//                     year === el.toString()
//                       ? styles.news_date_selectedYear
//                       : styles.news_date_year
//                   }
//                   onClick={() => selectYear(el)}
//                   type="button"
//                   aria-label={`year_${el}`}
//                 >
//                   {el}
//                 </button>
//               ))}

//               <button
//                 title={t("all")}
//                 className={
//                   year === "all"
//                     ? styles.news_date_selectedYear
//                     : styles.news_date_year
//                 }
//                 onClick={() => selectYear("all")}
//                 type="button"
//                 aria-label="all"
//               >
//                 {t("all")}
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="container">
//           {!data?.length ? (
//             <Loader />
//           ) : !filteredNews?.length ? (
//             <h3 className={styles.news_noResult}>0 {t("search_result")}</h3>
//           ) : (
//             <div>
//               <div className={styles.news_row}>
//                 {currentNews?.map(({ id, image, title, description }) => (
//                   <div
//                     key={id}
//                     title={title}
//                     className={styles.news_col}
//                     onClick={() => navigate(`${id}`)}
//                   >
//                     <h3>{title}</h3>
//                     <p>{description}</p>
//                     <img src={image} alt={`news${id}`} loading="lazy" />
//                   </div>
//                 ))}
//               </div>

//               {pageCount > 1 && (
//                 <ReactPaginate
//                   breakLabel="..."
//                   onPageChange={handlePageClick}
//                   pageRangeDisplayed={1}
//                   pageCount={pageCount}
//                   previousLabel={page > 1 ? arrowPrev : null}
//                   nextLabel={page < pageCount ? arrowNext : null}
//                   renderOnZeroPageCount={null}
//                   containerClassName={styles.pagination}
//                   activeClassName={styles.paginationActive}
//                   forcePage={page - 1}
//                 />
//               )}
//             </div>
//           )}
//         </div>
//       </main>
//     </>
//   );
// };

// export default News;

// V2
import { Meta } from "../../meta/meta";
import useMediaQuery from "../../hooks/useMediaQuery";
import { useTranslation } from "react-i18next";
import { Loader } from "../../components/ui/loader";
import useQueryParams from "../../hooks/useQueryParams";
import { Title } from "../../components/ui/typography/title";
import { GoBack } from "../../components/ui/goBack";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { getYearFromDateString } from "../../utils/formatters";
import { useTanstack } from "../../hooks/useTanstack";
import { smoothScroll } from "../../utils/helpers";
import styles from "./news.module.scss";

const News = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data } = useTanstack("getWebNews");
  const mobile = useMediaQuery(`( max-width: 768px )`);

  const currentYear = new Date().getFullYear();
  const [{ year, page }, setQuery] = useQueryParams({
    year: "all",
    page: 1,
  });

  const currentPage = Number(page) || 1;

  const years = Array.from(
    { length: currentYear - 2023 + 1 },
    (_, index) => 2023 + index
  );

  const filteredNews =
    year === "all"
      ? data
      : data?.filter(
          (item) => getYearFromDateString(item.date) === Number(year)
        );

  const itemsPerPage = 6;
  const pageCount = Math.ceil((filteredNews?.length || 0) / itemsPerPage);
  const itemOffset = (currentPage - 1) * itemsPerPage;
  const currentNews = filteredNews?.slice(
    itemOffset,
    itemOffset + itemsPerPage
  );

  const selectYear = (selectedYear) => {
    setQuery({ year: selectedYear, page: 1 });
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setQuery({ page: selectedPage });
    smoothScroll();
  };

  const arrowPrev = !mobile ? t("prev") : "<";
  const arrowNext = !mobile ? t("next") : ">";

  return (
    <>
      <Meta title="news" />
      <main className={styles.news}>
        <div className="container">
          <div className={styles.news_top}>
            <GoBack />
            <Title text="news" />
          </div>
        </div>

        <div className={styles.news_date}>
          <div className="container">
            <div className={styles.news_date_main}>
              {years.map((el) => (
                <button
                  key={el}
                  className={
                    year === el.toString()
                      ? styles.news_date_selectedYear
                      : styles.news_date_year
                  }
                  onClick={() => selectYear(el)}
                  type="button"
                  aria-label={`year_${el}`}
                >
                  {el}
                </button>
              ))}

              <button
                title={t("all")}
                className={
                  year === "all"
                    ? styles.news_date_selectedYear
                    : styles.news_date_year
                }
                onClick={() => selectYear("all")}
                type="button"
                aria-label="all"
              >
                {t("all")}
              </button>
            </div>
          </div>
        </div>

        <div className="container">
          {!data?.length ? (
            <Loader />
          ) : !filteredNews?.length ? (
            <h3 className={styles.news_noResult}>0 {t("search_result")}</h3>
          ) : (
            <div>
              <div className={styles.news_row}>
                {currentNews?.map(({ id, image, title, description }) => (
                  <div
                    key={id}
                    title={title}
                    className={styles.news_col}
                    onClick={() => navigate(`${id}`)}
                  >
                    <h3>{title}</h3>
                    <p>{description}</p>
                    <img src={image} alt={`news${id}`} loading="lazy" />
                  </div>
                ))}
              </div>

              {pageCount > 1 && (
                <ReactPaginate
                  breakLabel="..."
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={1}
                  pageCount={pageCount}
                  previousLabel={currentPage > 1 ? arrowPrev : null}
                  nextLabel={currentPage < pageCount ? arrowNext : null}
                  renderOnZeroPageCount={null}
                  containerClassName={styles.pagination}
                  activeClassName={styles.paginationActive}
                  forcePage={currentPage - 1}
                />
              )}
            </div>
          )}
        </div>
      </main>
    </>
  );
};

export default News;
